import { Component, Input, OnInit } from '@angular/core';
import { ITransaction, ITransactionPayment } from '../../services/sale.service';

@Component({
  selector: 'transaction-detail',
  templateUrl: './transaction-detail.component.html',
  styleUrls: ['./transaction-detail.component.scss']
})
export class TransactionDetailComponent implements OnInit {
  @Input() transaction: ITransaction | undefined
  constructor() { }

  ngOnInit(): void {
  }
  
  public merchantRef(): string {
    //Theoretically every transaction should have only one merch ref, so we want to grab the first instance of it in the payments.
    let merchRef = '';
    let payment = this.transaction.payments.find( payment => payment.enhancements?.some(enhancement => enhancement.key === 'UTR'));
    if(payment) {
      merchRef = payment.enhancements.find(x => x.key === 'UTR')?.value ?? '';
    }
    return merchRef;
  }
}
